import { render, staticRenderFns } from "./categoryform.vue?vue&type=template&id=723b5af2&scoped=true&"
import script from "./categoryform.vue?vue&type=script&lang=js&"
export * from "./categoryform.vue?vue&type=script&lang=js&"
import style0 from "./categoryform.vue?vue&type=style&index=0&id=723b5af2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723b5af2",
  null
  
)

export default component.exports